/* ============================================================
 * c-10ml-reveal.js
 * 10mlの日 ページ専用 — スクロール連動リビール + Heroパララックス
 *
 * - 対象: .c-10ml-fade-up / .c-10ml-mask-up
 * - 段階表示: 親に [data-c-10ml-stagger] を付けると子要素を順次表示
 * - パララックス: [data-c-10ml-parallax="0.2"] で速度比指定（PCのみ）
 * - prefers-reduced-motion / モバイル幅では無効化
 * ============================================================ */
(function () {
  'use strict';

  var REVEAL_SELECTOR = '.c-10ml-fade-up, .c-10ml-mask-up';
  var STAGGER_CONTAINER = '[data-c-10ml-stagger]';
  var PARALLAX_SELECTOR = '[data-c-10ml-parallax]';
  var DESKTOP_QUERY = '(min-width: 769px)';
  var REDUCE_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  function init() {
    var reduceMotion = window.matchMedia(REDUCE_MOTION_QUERY).matches;
    var revealEls = document.querySelectorAll(REVEAL_SELECTOR);

    if (reduceMotion || !('IntersectionObserver' in window)) {
      // モーション削減 or IO非対応 → 全要素を即座に可視化
      for (var i = 0; i < revealEls.length; i++) {
        revealEls[i].classList.add('is-visible');
      }
      return;
    }

    setupStagger();
    setupReveal(revealEls);

    if (window.matchMedia(DESKTOP_QUERY).matches) {
      setupParallax();
    }
  }

  // 親 [data-c-10ml-stagger] 配下の reveal 要素に index を付与
  function setupStagger() {
    var containers = document.querySelectorAll(STAGGER_CONTAINER);
    containers.forEach(function (container) {
      var children = container.querySelectorAll(REVEAL_SELECTOR);
      children.forEach(function (child, idx) {
        child.style.setProperty('--c-10ml-stagger-i', idx);
      });
    });
  }

  // IntersectionObserver で .is-visible を付与
  function setupReveal(revealEls) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Hero 背景画像のパララックス（PCのみ・rAF制御）
  function setupParallax() {
    var els = document.querySelectorAll(PARALLAX_SELECTOR);
    if (!els.length) return;

    var scrollY = 0;
    var ticking = false;

    function update() {
      els.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-c-10ml-parallax')) || 0.2;
        // 上限: 64px までに制限（過剰な動きを防止）
        var offset = Math.min(scrollY * speed, 200);
        el.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
      });
      ticking = false;
    }

    function onScroll() {
      scrollY = window.scrollY || window.pageYOffset;
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
